import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private http: HttpClientWrapperService) {
  }
  getStateList(productName: string) {
    return this.http.get(`common/${productName}/GetStateCodeList`);
  }

  getCityList(productName: string, stateID: number) {
    return this.http.get(`common/${productName}/GetCityCodeList?stateCode=${stateID}`, null);
  }
}
